<template lang="pug">
.recommend-out-container
  .recommend-container
    img.save-money-pic(v-if="vipRecommendPic" :src="vipRecommendPic")
    template(v-else)
      img.save-money-icon(src="https://m.hellobike.com/f03d6491_1828.png")
      HighlightText.text(
        :text="vipRecommendText"
        :normalStyle="normalCardStyle"
        :highlightStyle="highlightCardStyle"
      )
</template>

<script>
import HighlightText from '@/components/highlight-text.vue';

export default {
  name: 'VipRecommendWords',
  components: {
    HighlightText,
  },
  props: {
    vipRecommendText: {
      type: String,
      default: '',
    },
    vipRecommendPic: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      normalCardStyle: {
        color: '#4E3A28',
        fontSize: '0.13rem',
      },
      highlightCardStyle: {
        color: '#FA4614',
        fontSize: '0.13rem',
      },
    };
  },
  created() {

  },
  mounted() {

  },
  methods: {

  },
};
</script>
<style lang="less" scoped>
.recommend-out-container {
  //由于直接recommend-container写margintop会和外部容器重叠，所以新写个容器，单独设置padding-top
  padding-top: 0.16rem;
}

.recommend-container {
  width: calc(100% - 0.24rem);
  background: linear-gradient(90deg, #fff7eb 46.78%, rgba(255, 247, 235, 0) 100%);
  height: 0.35rem;
  border-radius: 0.12rem;
  margin: 0 auto;
  // margin: 0 auto;
  position: relative;

  .save-money-pic {
    height: 0.35rem;
    object-fit: contain;
  }

  .save-money-icon {
    width: 0.4rem;
    height: 0.4rem;
    position: absolute;
    left: 0.08rem;
    bottom: 0.04rem;
  }

  .text {
    margin-left: 0.54rem;
    font-family: PingFang SC, sans-serif;
    line-height: 0.35rem;
    font-weight: 500;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: visible;
  }
}
</style>
